import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class CourtService extends BaseApiService {
    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }

    // Gets the case
    public getAll() {
        return this.get('Incident/courts/list');
    }
}
